import React, {useRef} from "react";
import Table from "../Table/Table";
import {Col, Spinner} from "react-bootstrap";
import Dropdown, {components} from "react-select";
import {RiArrowDownSFill} from "react-icons/ri";
import {useContext} from "react";
import {store} from "../../Store/store";
import {useState} from "react";
import {getVmaLabelByUuid, snakeCaseToNormalString, updateControlUnitDetails, updateVmaItems} from "../../General/SharedMethods";
import {METERS_LOW_CASE} from "../../Constants/constants";

export default function MetersTable({
                                        data,
                                        isUpdateDetailsRequestInProgress,
                                        isApplyingActive,
                                        updateVmaListArr,
                                        controlUnitDetails,
                                        vmaData,
                                        setControlUnitDetails,
                                        connectivityStatusFormatter,
                                        nameFormatter,
                                        tableHeight
                                    }) {
    const colStyle = {minWidth: 100, fontSize: 14, whiteSpace: 'nowrap', paddingTop: 15};
    const textColStyle = {maxWidth: 100, fontSize: 14, whiteSpace: 'nowrap', paddingTop: 10};
    const filtersRefs = useRef([]);
    const idFilterRef = useRef();
    const pulseRatioFilterRef = useRef();
    const diameterFilterRef = useRef();
    const vmaFilterRef = useRef();
    const [sortState, setSortState] = useState({dataField: 'order', order: 'asc'});

    const resetFilters = () => {
        filtersRefs.current.forEach(currFilter => {
            if (currFilter) currFilter('');
        })
        idFilterRef.current?.resetFilter();
        pulseRatioFilterRef.current?.resetFilter();
        diameterFilterRef.current?.resetFilter();
        vmaFilterRef.current?.resetFilter();
    }

    const customDropdownStyles = {
        control: (provided) => ({
            fontSize: 14,
            ...provided
        }),
        option: (provided) => ({
            ...provided,
            fontSize: 14,
            minHeight: 40,
        })
    }
    const DropdownIndicator = props => {
        return (components.DropdownIndicator && (<components.DropdownIndicator {...props}>
            <RiArrowDownSFill color={'black'} size={20}/>
        </components.DropdownIndicator>));
    };

    const vmaDropDownFormatter = (cell, row) => {
        return (
            <VmaDropDown row={row}/>
        )
    }

    const onSort = (field, order) => {
        setSortState({dataField: field, order: order});
    }

    const columns = [
        {dataField: 'connectivityStatus', text: <div>Connectivity <br/> Status</div>, headerStyle: {width: 50, fontSize: 14}, style: colStyle, formatter: connectivityStatusFormatter, editable: false},
        {dataField: 'waterSystem', text: 'Water System', formatter: nameFormatter, headerStyle: {width: 200, fontSize: 14, paddingBottom: 15}, style: textColStyle, editable: false},
        {dataField: 'pulseRatio', text: 'Pulse Ratio', headerStyle: {width: 50, fontSize: 14, paddingBottom: 15}, style: colStyle, editable: false},
        {dataField: 'diameter', text: 'Diameter', headerStyle: {width: 50, fontSize: 14, paddingBottom: 15}, style: colStyle, editable: false},
        {dataField: 'vma', text: 'VMA', headerStyle: {minWidth: 200, fontSize: 14, paddingBottom: 15}, formatter: vmaDropDownFormatter, editable: false},
        {dataField: 'role', text: 'Role', headerStyle: {width: 100, fontSize: 14, paddingBottom: 15}, style: {minWidth: 80, fontSize: 14, whiteSpace: 'nowrap', paddingTop: 15}, formatter: snakeCaseToNormalString, editable: false},
    ];

    if (isUpdateDetailsRequestInProgress && !isApplyingActive) {
        return (<Col md={{offset: 5, span: 1}}><Spinner animation="border" variant="primary"/></Col>)
    } else {
        return (<div style={{overflowX: 'hidden', overflowY: 'auto', height: tableHeight}}>
            <Table
                isHeadersSticky={!tableHeight}
                data={data}
                columns={columns}
                disablePagination
                pageSize={15}
                resetFilters={resetFilters}
                defaultSort={sortState}
            />
        </div>)
    }

    function VmaDropDown({row}) {
        const stateObj = useContext(store);
        const [previousValue, setPreviousValue] = useState({value: row.vma?.uuid, label: getVmaLabelByUuid(row.vma?.uuid, stateObj)});

        return (
            <Dropdown
                menuPosition={'fixed'}
                menuPortalTarget={document.body}
                styles={customDropdownStyles}
                options={stateObj.state.dropdownOptionsArr}
                defaultValue={previousValue}
                components={{
                    IndicatorSeparator: () => null, DropdownIndicator
                }}
                onChange={(value) => {
                    const updatedVmaList = updateVmaItems(value.value, row.uuid, previousValue, METERS_LOW_CASE, stateObj);
                    updateVmaListArr(updatedVmaList);
                    updateControlUnitDetails(updatedVmaList, stateObj.state.cuDetails, vmaData, setControlUnitDetails, METERS_LOW_CASE);
                    setPreviousValue(value);
                }}
            />)
    }
}


